import { ButtonVariant } from '@client/new/pages/workout/components/addFromLibrary/mappers';
import { ButtonColor } from '@design-system/components/button/button.css';
import {
  StartExclusiveBundleDispatcher,
  StartExclusiveBundleSteps,
} from './startExclusiveBundle.vm';

export const getStepCta = ({
  step,
  dispatch,
  isSubmitting,
}: {
  step: StartExclusiveBundleSteps;
  dispatch: StartExclusiveBundleDispatcher;
  isSubmitting: boolean;
}) => {
  switch (step) {
    case 1:
      return [
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 2),
        },
      ];
    case 2:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setStep', 1),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'I’m not ready yet',
          onClick: () => dispatch('cancel'),
          variant: 'text' as ButtonVariant,
          className: 'ml-auto mr-2',
          color: 'primary' as ButtonColor,
        },
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 3),
        },
      ];
    case 3:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setStep', 2),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 4),
        },
      ];
    case 4:
      return [
        {
          title: 'Back',
          onClick: () => dispatch('setStep', 3),
          variant: 'text' as ButtonVariant,
        },
        {
          title: 'Switch to Exclusive Subscription',
          onClick: () => dispatch('create'),
          submitting: isSubmitting,
        },
      ];
    default:
      return [
        {
          title: 'Continue',
          onClick: () => dispatch('setStep', 2),
        },
      ];
  }
};
